import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { forgotPassword } from '../cognitoService';
import { isAllowedRedirectDomain } from '../utils/clientNames';
import Footer from '../components/Footer';
import './Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [redirectToClient, setRedirectToClient] = useState('');
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const redirectParam = urlParams.get('redirectToClient');
    if (redirectParam && isAllowedRedirectDomain(redirectParam)) {
      setRedirectToClient(redirectParam);
    }
    const emailParam = urlParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location.search]);

  const loginUrl = `/login${redirectToClient ? `?redirectToClient=${encodeURIComponent(redirectToClient)}` : ''}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');
    setIsBlocked(false);

    try {
      const result = await forgotPassword(email);
      if (result.authMethod === 'sso') {
        setIsBlocked(true);
        setMessage(result.message || 'This account uses Single Sign-On. Password reset is not available. Please log in using your organisation\'s SSO.');
      } else if (result.authMethod === 'force_change_password') {
        setIsBlocked(true);
        setMessage('This account has not completed initial setup. Please contact support@bergregions.pl to receive a new temporary password.');
      } else {
        setMessage('If your account exists and uses email/password authentication, you will receive a password reset code.');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const showForm = !message && !isBlocked;

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src="/logo.svg" alt="Berg" className="login-logo" />
          <h2>Reset Password</h2>
          {showForm && <p>Enter your email address and we'll send you a reset code.</p>}
        </div>

        {message && (
          <div className={`message ${isBlocked ? 'error-message' : 'success-message'}`}>
            {message}
          </div>
        )}

        {error && (
          <div className="message error-message">
            {error}
          </div>
        )}

        {showForm && (
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                disabled={isLoading}
              />
            </div>

            <button
              type="submit"
              className={`login-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner"></span>
                  Sending...
                </>
              ) : (
                'Send Reset Code'
              )}
            </button>

            <div className="login-links">
              <Link to={loginUrl} className="login-link">
                Back to Login
              </Link>
            </div>
          </form>
        )}

        {message && (
          <div className="login-links" style={{ marginTop: '16px' }}>
            <Link to={loginUrl} className="login-link">
              Back to Login
            </Link>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default ForgotPassword;
